import { React, Link, useState, storage, connect } from '../libraries'
import { logoutUser } from '../modules/redux/actions'
import logo from '../assets/images/logo2.svg'
import { Container, Col, Navbar as MainNav, Nav } from 'react-bootstrap';

const Navbar = ({ handleChangeTheme, logoutUser, checked }) => {
  const [toggle, setToggle] = useState(false)
  const handleToggle = e => {
    e.preventDefault()
    setToggle(!toggle)
  }

  const handleLogout = () => {
    storage.removeItem('token')
    storage.removeItem('vote')
    logoutUser()
  }

  return (
    <>
      <div className='navbar-top-line' />
      <Nav className='navbar navbar-expand-lg navbar-dark pt-0'>
        <Container fluid className='navbar-container'>
          <Col xs={12} className='flex-nav'>
            <div>
              <Link to='/'><img src={logo} width='200px' alt='img-logo' className='img-logo' /></Link>
            </div>
            <div>
              <MainNav.Toggle onClick={handleToggle} />
            </div>
            <div className='hidden-xs'>
              <ul className='nav navbar-nav'>
                <li>
                  <Link className='nav-item nav-link' to='/'>
                    <b>HOME</b>
                  </Link>
                </li>
                <li>
                  <Link className='nav-item nav-link' to='/about'>
                    <b>ABOUT PPU</b>
                  </Link>
                </li>
                {/* <li>
                  <Link className='nav-item nav-link' to='/article'>
                    <b>ARTICLE</b>
                  </Link>
                </li> */}
                {/* <li>
                  <Link className='nav-item nav-link' to='/events'>
                    <b>EVENTS</b>
                  </Link>
                </li> */}
                <li>
                  <Link className='nav-item nav-link' to='/peraturan-pemilu'>
                    <b>PERATURAN & FORM PEMILU</b>
                  </Link>
                </li>
                <li>
                  <Link className='nav-item nav-link' to='/syarat-balon'>
                    <b>SYARAT BALON KETUM </b>
                  </Link>
                </li>
                {/* <li><Link className='nav-item nav-link' to='/gallery'><b>GALLERY</b></Link></li> */}
                {storage.getItem('token') && <li><Link className='nav-item nav-link' to='/vote'><b>VOTE</b></Link></li>}
                {/* <li>
                  <Link className='nav-item nav-link' to='/register'>
                    <b>PENDAFTARAN</b>
                  </Link>
                </li> */}
                {
                  <li>
                    {storage.getItem('token') ? (
                      <Link
                        to='/login'
                        className='nav-item nav-link'
                        onClick={handleLogout}
                      >
                        <b>LOGOUT</b>
                      </Link>
                    ) : (
                      <Link className='nav-item nav-link' to='/login'>
                        <b>LOGIN</b>
                      </Link>
                    )}
                  </li>
                }
                {/* <li onClick={handleChangeTheme}>
                  <span className='nav-item nav-link' style={{ cursor: 'pointer' }}>
                    <b>{checked}</b>
                  </span>
                </li> */}
              </ul>
            </div>
          </Col>
        </Container>
      </Nav>
      <Col
        xs={12}
        className={
          toggle ? 'text-center navbar-slider-xs hidden-lg ' : 'd-none'
        }
      >
        <Link to='/'>
          <p>
            <b>HOME</b>
          </p>
        </Link>
        <Link to='/about'>
          <p>
            <b>ABOUT PPU</b>
          </p>
        </Link>
        {/* <Link to='/article'>
          <p>
            <b>ARTICLE</b>
          </p>
        </Link> */}
        {/* <Link to='/events'>
          <p>
            <b>EVENTS</b>
          </p>
        </Link> */}
        <Link to='/peraturan-pemilu'>
          <p>
            <b>PERATURAN & FORM PEMILU</b>
          </p>
        </Link>
        {storage.getItem('token') && <Link to='/vote'><p><b>VOTE</b></p></Link>}
        <Link to='/syarat-balon'>
          <p>
            <b>SYARAT BALON KETUM </b>
          </p>
        </Link>
        {storage.getItem('token') && <Link className='nav-item nav-link' to='/vote'><b>VOTE</b></Link>}
        {/* <Link to='/register'>
          <p><b>PENDAFTARAN</b></p>
        </Link> */}
        {storage.getItem('token') ? (
          <Link to='/login' onClick={() => storage.removeItem('token')}>
            <p><b>LOGOUT</b></p>
          </Link>
        ) : (
          <Link to='/login'>
            <p><b>LOGIN</b></p>
          </Link>
        )}
        {/* <span className='nav-item nav-link' style={{ cursor: 'pointer' }} onClick={handleChangeTheme}>
          <b>{checked}</b>
        </span> */}
      </Col>
    </>
  )
}

const mapDispatchToProps = {
  logoutUser
}

export default connect(null, mapDispatchToProps)(Navbar)
